export default {
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} ist der maximale Trinkgeldwert',
      },
    },
  },
};
